__turbopack_context__.v({
  "drift": "Stars-module-scss-module__8EjYMW__drift",
  "field": "Stars-module-scss-module__8EjYMW__field",
  "fieldFar": "Stars-module-scss-module__8EjYMW__fieldFar",
  "fieldMid": "Stars-module-scss-module__8EjYMW__fieldMid",
  "fieldPrimary": "Stars-module-scss-module__8EjYMW__fieldPrimary",
  "root": "Stars-module-scss-module__8EjYMW__root",
});
